<template>
  <div id="app">
    <v-header></v-header>
      <el-main >
        <div class="bgcolor" :style="autoHeight" >
          <!-- <router-view ref="height" /> -->
          <!--keep-alive返回不刷新-->
          <keep-alive >
            <router-view  ref="height"  v-if="$route.meta.keepAlive"/>
          </keep-alive>
          <router-view  ref="height"  v-if="!$route.meta.keepAlive"/>

        </div>
      </el-main>

    <el-footer>技术支持：<a href="http://www.foodmate.net/" target="_blank">食品伙伴网</a></el-footer>
  </div>

</template>

<script>
import header from '@/components/header'
let windowHeight = parseInt(window.innerHeight)

export default {
  name: 'App',
  data() {
    return {
      autoHeight: {
        minHeight: ''
      },
    };
  },
  components: {
    'v-header':header
  },
  mounted() {
    this.autoHeight.minHeight = (parseInt(window.innerHeight) - 180) + "px";
    this.$refs['height'].$el.style.minHeight = (parseInt(window.innerHeight) - 177) + "px";
    window.onresize = () => {
      return (() => {
        this.autoHeight.minHeight = (parseInt(window.innerHeight) - 180) + "px";
        this.$refs['height'].$el.style.minHeight = (parseInt(window.innerHeight) - 177) + "px";
      })();
    };
  },
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  background-color: #f7f7f7;
  font-family: "PingFang SC","Microsoft YaHei","微软雅黑",Arial,"Helvetica Neue",Helvetica,"Hiragino Sans GB",sans-serif;
}
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
footer{
  height: 52px !important;
  line-height: 52px;
  text-align: center;
  background: #333;
}
footer,footer a{
  color: #fff;
  font-size: 14px;
  text-decoration: none;
}
.el-main{
  padding-bottom: 0;
}
.bgcolor{
  position: relative;
  width: 100%;
  padding: 10px 40px 0;
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
}
h2{
  padding: 0 12px;
  font-size: 16px;
  line-height: 44px;
  color: #2469B7;
  font-weight: normal;
}
.block{
  margin-top: 20px;
  text-align: right;
}
.display-flex{
  display: flex;
}
.align-center{
  align-items: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-center{
  justify-content: center;
}
.moblie-show{
  display: none !important;
}
.pc-show{
  display: block !important;
}
@media screen and (max-width:750px) {
  .moblie-show{
    display: block !important;
  }
  .pc-show{
    display: none !important;
  }
  .bgcolor{
    padding: 10px 20px 0;
  }
  .el-main{
    padding: 0 !important;
  }
  .el-main .el-pager{
    display: none;
  }
  .el-main .el-pagination__sizes{
    margin-right: 0;
  }
  .el-main .el-pagination .el-select .el-input{
    margin-right: 0;
  }
  .el-main .el-pagination__jump{
    display: block !important;
    margin-top: 16px;
  }
  .el-form--inline .el-form-item{
    width: 100%;
    margin-right: 0;
  }
  .el-form--inline .el-form-item__label{
    display: block;
    width: 100% !important;
    text-align: left;
    line-height: 1;
    margin-bottom: 8px;
  }
  .el-form--inline .el-form-item__content{
    width: 100%;
  }
  .el-form--inline .el-form-item__content .el-cascader{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue